// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import setIsSearchPage from "@insite/client-framework/Store/Pages/ProductList/Handlers/SetIsSearchPage";
import translate from "@insite/client-framework/Translate";
import { AutocompleteItemModel, BrandAutocompleteModel } from "@insite/client-framework/Types/ApiModels";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import styled from "styled-components";
import { autocompleteProps } from "@store/Themes/common/props/autocomplete";
// Store Custom Code
import ArrowRight from "@insite/mobius/Icons/ArrowRight";
import Icon from "@insite/mobius/Icon";

interface OwnProps {
    brands: BrandAutocompleteModel[] | null;
    popularBrands?: BrandAutocompleteModel[] | null;
    focusedItem?: AutocompleteItemModel;
    goToUrl: (url: string) => void;
    extendedStyles?: AutocompleteBrandsStyles;
    isRetailSearchCompletionResults?: boolean;
}

const mapDispatchToProps = {
    setIsSearchPage,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps>;

export interface AutocompleteBrandsStyles {
    headerText?: TypographyPresentationProps;
    subHeaderText?: TypographyPresentationProps;
    brandItemText?: TypographyPresentationProps;
    divider?: InjectableCss;
    focusedBrandItemText?: TypographyPresentationProps;
    link?: LinkPresentationProps;
    focusedLink?: LinkPresentationProps;
    autocompleteBrandsRowWrapper?: InjectableCss;
    autocompleteBrandsColumnWrapper?: InjectableCss;
    note?: TypographyPresentationProps;
}

export const autocompleteBrandsStyles: AutocompleteBrandsStyles = {
    headerText: autocompleteProps.headerText,
    autocompleteBrandsColumnWrapper: autocompleteProps.autocompleteColumnWrapper,
    subHeaderText: autocompleteProps.subHeaderText,
    link: autocompleteProps.link,
    focusedLink: autocompleteProps.focusedLink,
    note: autocompleteProps.note,
};

const styles = autocompleteBrandsStyles;

/* Store Custom Code - a leading navigation icon before each row */
const ItemRow = styled.li`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const List = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;
`;

class AutocompleteBrands extends React.Component<Props> {
    private readonly styles: AutocompleteBrandsStyles;

    constructor(props: Props) {
        super(props);

        this.styles = mergeToNew(styles, props.extendedStyles);
    }

    renderBrands = (brands: BrandAutocompleteModel[]) => {
        const styles = this.styles;
        return (
            <List>
                {brands.map(brand => (
                    /* Store Custom Code - Start */
                    <ItemRow key={`${brand.id}_${brand.productLineId}`}>
                        <Icon src={ArrowRight} size={16} color="#5C6163" />
                        <Link
                            {...(this.props.focusedItem === brand ? styles.focusedLink : styles.link)}
                            onClick={() => {
                                this.props.setIsSearchPage(false);
                                this.props.goToUrl(brand.url);
                            }}
                            data-test-selector={
                                brand.productLineName ? `productLineId_${brand.productLineId}` : `brandId_${brand.id}`
                            }
                            className="autocomplete-brands-link"
                        >
                            {brand.productLineName ? (
                                <>
                                    {brand.displayProductLineName}
                                    <Typography {...styles.note} className="autocomplete-brands-note">
                                        <>{` ${translate("in")}`}</> {brand.displayTitle}
                                    </Typography>
                                </>
                            ) : (
                                brand.displayTitle
                            )}
                        </Link>
                    </ItemRow>
                    /* Store Custom Code - End */
                ))}
            </List>
        );
    };

    render() {
        const { brands, popularBrands, isRetailSearchCompletionResults } = this.props;
        if ((!brands || brands.length === 0) && (!popularBrands || popularBrands.length === 0)) {
            return null;
        }

        const styles = this.styles;
        return (
            <>
                <Typography
                    {...styles.headerText}
                    data-test-selector="autocompleteBrands_Header"
                    className="autocomplete-brands-header"
                >
                    {translate("Brands")}
                </Typography>

                {brands && brands.length > 0 && !isRetailSearchCompletionResults && this.renderBrands(brands)}

                {isRetailSearchCompletionResults && (
                    <>
                        {popularBrands && popularBrands.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteBrandsColumnWrapper}
                                className="autocomplete-brands-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteBrands_subHeader"
                                    className="autocomplete-brands-subheader"
                                >
                                    {translate("popular")}
                                </Typography>
                                {this.renderBrands(popularBrands)}
                            </StyledWrapper>
                        )}
                        {brands && brands.length > 0 && (
                            <StyledWrapper
                                {...this.styles.autocompleteBrandsColumnWrapper}
                                className="autocomplete-brands-column-wrapper"
                            >
                                <Typography
                                    {...styles.subHeaderText}
                                    data-test-selector="autocompleteBrands_subHeader"
                                    className="autocomplete-brands-subheader"
                                >
                                    {translate("suggested")}
                                </Typography>
                                {this.renderBrands(brands)}
                            </StyledWrapper>
                        )}
                    </>
                )}
            </>
        );
    }
}

export default connect(null, mapDispatchToProps)(AutocompleteBrands);
